export type AlertType = { type: AlertKeys };

export const enum AlertKeys {
    cancel = 'cancel',
    transfer = 'transfer',
    error = 'error',
    success = 'success',
    none = 'none',
}
